import { stringify } from 'qs'
import { useCustomSWR } from 'utils/hooks/fetchers'
import RequestCore, { lsGetWithToken } from 'utils/request'

export const useCatalogs = (props = { limit: 999 }) => {
  const genUrl = () =>
    RequestCore.getToken()
      ? [`/catalogs?${stringify(props)}`, RequestCore.getToken()]
      : `/catalogs?${stringify(props)}`

  return useCustomSWR(genUrl, lsGetWithToken)
}
